<article class="card address-card" [ngClass]="'size--' + size">
  <div data-clarity-mask="true">
    @if (isDefaultAddress) {
      <span class="chip-label chip--outline chip--success float-none float-md-end mb-3">
        <app-icon anchor="icon-order-processed"></app-icon>
        <span class="ps-2">{{ prefix + 'standaard-label' | fromDictionary }}</span>
      </span>
    }
    <p class="mb-2">
      @if (address.company) {
        <span>
          {{ address.company }}
          <br />
        </span>
      }
      @if (address.name) {
        <span>
          {{ address.name }}
          <br />
        </span>
      }
      @if (address.address1) {
        <span class="d-inline-block me-1">{{ address.address1 }}</span>
      }
      @if (address.address2) {
        <span>{{ address.address2 }}</span>
      }
      @if (address.address1 || address.address2) {
        <br />
      }
      @if (address.zip) {
        <span class="d-inline-block me-1">{{ address.zip }}</span>
      }
      @if (address.city) {
        <span class="d-inline-block me-1">
          @if (address.country) {
            {{ address.city }},
          }
          @if (!address.country) {
            {{ address.city }}
          }
        </span>
      }
      @if (address.country) {
        <span>{{ address.country }}</span>
      }
      @if (address.zip || address.city || address.country) {
        <br />
      }
      @if (address.phone) {
        <span>{{ address.phone }}</span>
      }
    </p>
  </div>

  @if (!hideActions) {
    <footer class="mt-2">
      <ul class="d-flex justify-content-between">
        <span class="d-flex flex-wrap">
          <li class="me-3">
            <a [routerLink]="['/', 'account', 'edit-address', id]" type="button" class="button button-link button--muted-light">
              <app-icon anchor="icon-edit"></app-icon>
              <span class="button__label">{{ 'bewerken' | fromDictionary }}</span>
            </a>
          </li>
          <li class="me-3">
            <button type="button" class="button button-link button--muted-light" (click)="emitAction('delete')">
              @if (!(loading && loadingState?.action === 'isDeleting')) {
                <app-icon anchor="icon-delete"></app-icon>
              }
              @if (loading && loadingState?.action === 'isDeleting') {
                <span class="icon-loader css-icon" title="laden"></span>
              }
              <span class="button__label">{{ 'verwijderen' | fromDictionary }}</span>
            </button>
          </li>
        </span>
        @if (!isDefaultAddress) {
          <li class="me-3">
            <a (click)="emitAction('setDefault')" type="button" class="button button-link button--muted-light">
              @if (!(loading && loadingState?.action === 'setDefault')) {
                <app-icon anchor="icon-order-processed"></app-icon>
              }
              @if (loading && loadingState?.action === 'setDefault') {
                <span class="icon-loader css-icon" title="laden"></span>
              }
              <span class="button__label">{{ prefix + 'stel-in-als-standaard' | fromDictionary }}</span>
            </a>
          </li>
        }
      </ul>
    </footer>
  }
</article>
